<template>
<div>
    <div class="row">
        <div class="col">
          <a href="/" class="btn btn-success mr-2 mb-2 mb-md-0"><i class="fa-solid fa-arrow-left pr-1"></i>Back to search</a>
          <a v-if="!loading && (userInfo.account=='Admin' || property.user_id == userInfo.id)" :class="'btn btn-success Status '+property.status+' mb-2 mb-md-0'" @click="doNothing()">{{property.status}}</a>
          </div>

        <div class="col text-right">
          <span v-if="!loading && userInfo">
          <span v-if="userInfo.account=='Admin' || property.user_id == userInfo.id">
          <a :href="'/products/edit/'+property.id" class="btn btn-primary mb-2 mb-md-0">Edit product</a>
          <a v-if="property.status=='Active'" href="#/" class="btn btn-danger ml-2 mb-2 mb-md-0" @click="updateStatus('Inactive')">Deactivate</a>
          <a v-if="property.status=='Inactive'" href="#/" class="btn btn-success ml-2 mb-2 mb-md-0" @click="updateStatus('Active')">Activate</a>
          </span>
          <span v-if="property.status=='In Review' && userInfo.account=='Admin'">
          <a href="#/" class="btn btn-success ml-2 mb-2 mb-md-0" @click="updateStatus('Active')">Approve</a>
          <a href="#/" class="btn btn-danger ml-2 mb-2 mb-md-0" @click="showModal()">Decline</a>
          </span>
          <a href="#/" @click="openShareModal()" class="btn btn-success ml-2 mb-2 mb-md-0"><i class="fas fa-share-alt mr-2"></i>Share</a>
          </span>
          </div>
      </div>

        <!-- start modal -->
        <b-modal id="bv-modal-example" hide-footer>
    <template #modal-title>
      Decline property
    </template>
<div>
  <div>
    <div>

      <div>
          
          <div class="row"><div class="col"><div class="form-group"><label for="dealer-name" class="form-label font-weight-bold">Reason</label> 
                   
          <textarea class="form-control shadow-none inputbox" rows="3" placeholder="Type message here" v-model="reason"></textarea>
                      
    </div></div></div> 

        </div>
      <div>
<button v-if="updating" type="button" class="btn btn-success col">
  <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i>Updating ...</button>
        <button v-else type="button" class="btn btn-danger col" @click="declineProperty">Decline property</button>
      </div>
    </div>
  </div>
</div>

  </b-modal>
  <!-- end modal -->

          <!-- start modal -->
        <b-modal id="bv-modal-share" hide-footer>
    <template #modal-title>
      Share property
    </template>
<div>
  <div>
    <div>

      <div>
          
          <div class="row">
            
            <div class="col"><div class="form-group"><label for="dealer-name" class="form-label font-weight-bold">Email address</label> 
                   
          <input class="form-control" type="text" v-model="email">  
                      
    </div>

    <div class="alert alert-danger mb-2 p-1 text-center" v-if="share_error">{{share_error}}</div>
    </div>
    
    </div> 

        </div>
      <div>
        
<button v-if="sharing" type="button" class="btn btn-success col">
  <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
        <button v-else type="button" class="btn btn-success col" @click="shareProperty">Share property</button>
      </div>
    </div>
  </div>
</div>

  </b-modal>
  <!-- end modal -->

</div>
</template>

<script>

export default {
props: ['property_id','user'],

  data() {
    return {
      property: {},
      loading: false,
      updating: false,
      sharing: false,
      share_error: '',
      userInfo: {},
      reason: '',
      email: '',
    };
  },

  created() {

    this.getPropertyInfo();
    if (this.user) this.userInfo = JSON.parse(this.user);
   
  },

  methods: {

    doNothing() {
      return false;
    },

    showModal() {
        this.reason = '';
        this.$bvModal.show('bv-modal-example');
      },

      openShareModal() {
        this.email = '';
        this.$bvModal.show('bv-modal-share');
      },

      closeShareModal() {
        this.$bvModal.hide('bv-modal-share');
      },

      hideModal() {
        this.$bvModal.hide('bv-modal-example');
      },

      shareProperty() {

          if (this.email.length < 1) {
            this.sweetfire2('Please enter email address');
          
          } else {

          this.share_error = '';

          this.sharing = true;

          axios.post('/products/share-property', {property_id: this.property.id, email: this.email})
        .then((response) => {
          if (response.data.success) {this.closeShareModal(); this.sweetfire2('Email sent to <b>'+this.email+'</b>');}
          else {this.share_error = response.data.message;}
          this.sharing = false;
        })
        .catch(function (error) {
          console.log(error);
          this.sharing = false;
        });

          }

      },

      declineProperty() {

          if (this.reason.length < 1) {
            this.sweetfire2('Please enter a reason');
          
          } else {

          this.updating = true;

          axios.post('/products/decline-property', {property: this.property, reason: this.reason})
        .then((response) => {
          console.log(response.data);
          this.hideModal();
          this.updating = false;
           this.getPropertyInfo();
           this.sweetfire2('Property has been declined');
        })
        .catch(function (error) {
          console.log(error);
          this.updating = false;
        });

          }

      },

      updateStatus(new_status) {

          this.updating = true;

          axios.post('/products/update-status', {new_status: new_status, property: this.property})
        .then((response) => {
          console.log(response.data);
          this.updating = false;
           this.getPropertyInfo();
            this.sweetfire2('Status has been updated');
        })
        .catch(function (error) {
          console.log(error);
          this.updating = false;
        });

      },

      sweetfire2(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },

    getPropertyInfo() {

      this.loading = true;

      axios.get("/products/getinfo/"+this.property_id)
           .then((response) => {
        this.property = response.data;
        this.loading = false;
      });
    },

  }

}

</script>

<style scoped>
.btn.btn-secondary.Status.Active, 
.btn.btn-secondary.Status.Active:hover, 
.btn.btn-secondary.Status.Active:active {background-color: #38c172; border-color:#38c172;color: #fff;}

.btn.btn-secondary.Status.In.Review, 
.btn.btn-secondary.Status.In.Review:hover, 
.btn.btn-secondary.Status.In.Review:active {background-color: #f68c14; border-color:#f68c14;color: #fff;}

.btn.btn-secondary.Status.Inactive, 
.btn.btn-secondary.Status.Inactive:hover, 
.btn.btn-secondary.Status.Inactive:active {background-color: #cf1a28; border-color:#cf1a28;color: #fff;}

.btn.btn-secondary.Status.Incomplete, 
.btn.btn-secondary.Status.Incomplete:hover, 
.btn.btn-secondary.Status.Incomplete:active {background-color: #1c2b33; border-color:#1c2b33;color: #fff;}

textarea{resize: none;}
.badge {padding: 0.75rem 0.8rem;}

</style>